import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'animate.css/animate.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faShoppingCart, faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Products from './components/Products.vue';
import Checkout from './components/Checkout.vue';

library.add(faShoppingCart, faDollarSign);
Vue.component('font-awesome-icon', FontAwesomeIcon);

console.log(VueRouter);
Vue.use(VueRouter);

Vue.config.productionTip = false;

const router = new VueRouter({
  routes: [
    {
      path: '*',
      component: Products
    },
    {
      path: '/checkout',
      component: Checkout
    }
  ]
});

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app');
